import { cn } from '@/utils/lib/cn';

export function Loader({ className }: { className?: string }) {
  return (
    <div className={cn('my-44 flex items-center justify-center', className)}>
      <div className='h-6 w-6 animate-spin rounded-full border-3 border-solid border-slate-100 border-l-red-500'></div>
    </div>
  );
}

export function Error() {
  return (
    <div className='my-44 flex items-center justify-center'>
      <p className='text-lg font-semibold text-red-400'>
        Something went wrong. Please try again later.
      </p>
    </div>
  );
}

export const SuspenseFallbackUI = () => {
  return (
    <div className='grid min-h-screen place-content-center'>
      <Loader />
    </div>
  );
};
